import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from 'reactstrap';
import { Col, Row } from 'reactstrap';
import { SubmitTrainEventRecordModel, TrainECPBModel, TrainEventRecordModel, TrainIncidentDetailsModel } from '../../../../shared/models/api/models';
import { submitTrainEventRecord } from '../../../../shared/services/TrainEventRecordApi';
import { getUserProfile } from '../../../../shared/services/userApi';
import { DateChoice, MultilineTextInput, TimeChoice, UserChoice } from '../../fatigueAssessment/FormControls';
import { trainEventRecordOverviewPathRoute } from '../OperationalFormsRoutes';
import { ECPBPressuresChoice, IncidentCheck, LineChoice, LoadChoice, LocationChoice, RadioCheck, ResultCheck, SingleLineTextInput, TrainBrakeChoice, YesNoCheck, YesNoChoice } from './FormControls';
import OperationalFormsQuestions from './TrainEventRecordQuestions';
import { fieldInvalid, handleChange, TrainEventRecordState, trainEventRecordState as te, handleSingleCheckboxChange, handleMultipleCheckboxChange, handlePressureChange, handleDurationDelayChange, enableValidation } from './TrainEventRecordState';
import { FormModal, FormModalPaddedBody, FormModalSubHeader, ModalButton, ModalButtonRow } from '../../../ui/FormModal';
import { InfoOutlined as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import { IncidentDetailsEnum } from '../../../../shared/enums/train-event-record-enum';
import { formatTime, toISOLocalDate } from '../../../../shared/models/mapping/mapping';
import { questionsUnanswered } from '../../forms/util';
import './TrainEventRecordSection.css'

interface MainFormProps {
    defaultEventTime?: string | undefined;
}

const MainForm = (props: MainFormProps) => {
    const [form, setForm] = useState({} as TrainEventRecordModel)
    const [defaultShiftStartTime, setDefaultShiftStartTime] = useState(formatTime(new Date()));
    const [showRadioFault, setShowRadioFault] = useState(false);
    const [showECPB, setShowECPB] = useState(false);
    const q = OperationalFormsQuestions;

    const getUserName = async () => {
        let profile = await getUserProfile();
        if (profile) {
            return `${profile.firstname} ${profile.lastname}`;
        }
        return "";
    }
    const [userName, setUserName] = useState("");

    const handleMouseOut = () => (event: any) => {
        let value = event;

        if (value.target?.value !== undefined) {
            value = value.target.value;
        }
        if (value.value !== undefined) {
            value = value.value;
        }
    }
    useEffect(() => {
        const sub = te.subscribe((d: TrainEventRecordState) => {
            setForm(d.form);
            const selectedIncidents: string[] = d.form.incident || [];
            (async () => {
                const name = await getUserName();
                setUserName(name);
            })();
            setShowRadioFault(selectedIncidents.includes(IncidentDetailsEnum.Radio.toString()));
            setShowECPB(selectedIncidents.includes(IncidentDetailsEnum.ECPB.toString()));
        });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    return (
        <div>
            <div className="main-form-row row-divider">
                <Row>
                    <Col sm="2">
                        <div className="te-question">{q.Date.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <DateChoice onAnswerUpdate={handleChange(q.Date.key)} />
                        </div></Col>
                    <Col sm="2">
                        <div className="te-question">{q.TrainSerialNumber.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <SingleLineTextInput
                                onAnswerUpdate={handleChange(q.TrainSerialNumber.key)}
                                invalid={fieldInvalid(q.TrainSerialNumber.key)}
                                placeholder={q.TrainSerialNumber.altValue} />
                        </div></Col>
                </Row>
            </div>
            <div className="main-form-row row-divider">
                <Row>
                    <Col sm="2">
                        <div className="te-question">{q.Time.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <Input type="time" id={q.Time.key} step={60} onChange={handleChange(q.Time.key)} value={form.eventTime ?? props.defaultEventTime} />
                        </div></Col>
                    <Col sm="2">
                        <div className="te-question">{q.DurationOfDelay.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <Input
                                type="text"
                                onChange={handleDurationDelayChange(q.DurationOfDelay.key)}
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab"];
                                    if (!/^\d$/.test(e.key) &&
                                        !allowedKeys.includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                placeholder={q.DurationOfDelay.altValue}
                                maxLength={7}
                            />
                        </div></Col>
                </Row>
            </div>
            <div className="main-form-row">
                <Row>
                    <Col sm="2">
                        <div className="te-question">{q.DriversName.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <Input
                                id={q.DriversName.key}
                                type="text"
                                required={true}
                                disabled={true}
                                maxLength={100}
                                value={userName} />
                        </div>
                    </Col>
                    <Col sm="2">
                        <div className="te-question">{q.DriversDepot.value}</div>
                    </Col>
                    <Col sm="4">
                        <div className="answer">
                            <LocationChoice onAnswerUpdate={handleChange(q.DriversDepot.key)} invalid={fieldInvalid(q.DriversDepot.key)} />
                        </div></Col>
                </Row>
            </div>

            <div>
                <div className="te-main-form-header"> {q.TrainDetails.value}</div>

                <div className="main-form-row row-divider">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.ALeadLoco.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <YesNoCheck name={q.ALeadLoco.key} onAnswerUpdate={handleSingleCheckboxChange(q.ALeadLoco.key)} />
                            </div>
                        </Col>
                        <Col sm="2">
                            <div className="te-question">{q.ATrailLoco.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <YesNoCheck name={q.ATrailLoco.key} onAnswerUpdate={handleSingleCheckboxChange(q.ATrailLoco.key)} />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-form-row row-divider">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.BRemoteLoco.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <YesNoCheck name={q.BRemoteLoco.key} onAnswerUpdate={handleSingleCheckboxChange(q.BRemoteLoco.key)} />
                            </div>
                        </Col>
                        <Col sm="2">
                            <div className="te-question">{q.BTrailLoco.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <YesNoCheck name={q.BTrailLoco.key} onAnswerUpdate={handleSingleCheckboxChange(q.BTrailLoco.key)} />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-form-row row-divider">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.TrainBrakeType.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <TrainBrakeChoice name={q.TrainBrakeType.key} onAnswerUpdate={handleMultipleCheckboxChange(q.TrainBrakeType.key)} invalid={fieldInvalid(q.TrainBrakeType.key)} />
                            </div>
                        </Col>
                        <Col sm="2">
                            <div className="te-question">{q.Percentageoperable.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <SingleLineTextInput onAnswerUpdate={handleChange(q.Percentageoperable.key)}
                                    invalid={fieldInvalid(q.Percentageoperable.key)}
                                    placeholder={q.Percentageoperable.altValue}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-form-row">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.LeaderActive.value}</div>
                        </Col>
                        <Col sm="4">
                            <div>
                                <YesNoChoice name={q.LeaderActive.key}
                                    onAnswerUpdate={handleChange(q.LeaderActive.key)}
                                    invalid={fieldInvalid(q.LeaderActive.key)}
                                />
                            </div>
                        </Col>
                        <Col sm="2">
                            <div className="te-question">{q.EOT.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <SingleLineTextInput onAnswerUpdate={handleChange(q.EOT.key)}
                                    invalid={fieldInvalid(q.EOT.key)}
                                    placeholder={q.EOT.altValue}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="te-main-form-header"> {q.SpecificLocation.value}</div>
            <div>
                <div className="main-form-row row-divider">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.Line.value}</div>
                        </Col>
                        <Col sm="4">
                            <div>
                                <LineChoice name={q.Line.key}
                                    onAnswerUpdate={handleChange(q.Line.key)}
                                    invalid={fieldInvalid(q.Line.key)}
                                />
                            </div>
                        </Col>
                        <Col sm="2">
                            <div className="te-question">{q.KmPeg.value}</div>
                        </Col>
                        <Col sm="4">
                            <div className="answer">
                                <SingleLineTextInput onAnswerUpdate={handleChange(q.KmPeg.key)}
                                    invalid={fieldInvalid(q.KmPeg.key)}
                                    placeholder={q.KmPeg.altValue}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-form-row row-divider">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.Loaded.value}</div>
                        </Col>
                        <Col sm="4">
                            <div >
                                <LoadChoice name={q.Loaded.key} onAnswerUpdate={handleSingleCheckboxChange(q.Loaded.key)} invalid={fieldInvalid(q.Loaded.key)} />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-form-row">
                    <Row>
                        <Col sm="2">
                            <div className="te-question">{q.WeatherConditions.value}</div>
                        </Col>
                        <Col sm="10">
                            <div >
                                <SingleLineTextInput onAnswerUpdate={handleChange(q.WeatherConditions.key)}
                                    invalid={fieldInvalid(q.WeatherConditions.key)}
                                    placeholder={q.WeatherConditions.altValue}
                                /> </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="te-main-form-header"> {q.IncidentDetails.value}</div>
            <div className="main-form-row row-divider">
                <Row>
                    <Col sm="2">
                        <div className="te-question">{q.IncidentDetails.value}</div>
                    </Col>
                    <Col sm="10">
                        <div>
                            <IncidentCheck name={q.IncidentDetails.key} onAnswerUpdate={handleMultipleCheckboxChange(q.IncidentDetails.key)}
                                invalid={fieldInvalid(q.IncidentDetails.key)} />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="main-form-row row-divider">
                <Row>
                    <Col sm="2">
                        <div className="te-question">{q.Result.value}</div>
                    </Col>
                    <Col sm="10">
                        <div>
                            <ResultCheck name={q.Result.key} onAnswerUpdate={handleMultipleCheckboxChange(q.Result.key)}
                                invalid={fieldInvalid(q.Result.key)} />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className={`main-form-row ${showRadioFault && "row-divider"}`}>
                <div className="te-question" dangerouslySetInnerHTML={{ __html: q.SequenceOfEvents.value }}></div>
                <div className="answer">
                    <MultilineTextInput onAnswerUpdate={handleChange(q.SequenceOfEvents.key)}
                        invalid={fieldInvalid(q.SequenceOfEvents.key)}
                    /> </div>
            </div>
            {showRadioFault &&
                <>
                    <div className="main-form-row row-divider">
                        <Row>
                            <Col sm="2">
                                <div className="te-question">{q.RadiofaultDetails.value}</div>
                            </Col>
                            <Col sm="4">
                                <div>
                                    <RadioCheck name={q.RadiofaultDetails.key} onAnswerUpdate={handleMultipleCheckboxChange(q.RadiofaultDetails.key)}
                                        invalid={fieldInvalid(q.RadiofaultDetails.key)} />
                                </div>
                            </Col>
                            <Col sm="2">
                                <div className="te-question">{q.HandheldSerialNo.value}</div>
                            </Col>
                            <Col sm="4">
                                <div >
                                    <SingleLineTextInput onAnswerUpdate={handleChange(q.HandheldSerialNo.key)}

                                        placeholder={q.HandheldSerialNo.altValue}
                                    /> </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="main-form-row">
                        <Row>
                            <Col sm="2">
                                <div className="te-question">{q.FaultArea.value}</div>
                            </Col>
                            <Col sm="2">
                                <div className="te-question">{q.KmStart.value}</div>
                            </Col>
                            <Col sm="3">
                                <div>
                                    <SingleLineTextInput onAnswerUpdate={handleChange(q.KmStart.key)}
                                        placeholder={q.KmStart.altValue} />
                                </div>
                            </Col>
                            <Col sm="2">
                                <div className="te-question">{q.KmFinish.value}</div>
                            </Col>
                            <Col sm="3">
                                <div >
                                    <SingleLineTextInput onAnswerUpdate={handleChange(q.KmFinish.key)}
                                        placeholder={q.KmFinish.altValue} /> </div>
                            </Col>
                        </Row>
                    </div>
                </>
            }

            <div className="te-main-form-header"> {q.DetailsofECPB.value}</div>
            <div className="main-form-row">
                <div className="te-question">{q.NoOfFlatBatteries.value}</div>
                <div className="answer">
                    <ECPBPressuresChoice onAnswerUpdate={handleChange(q.NoOfFlatBatteries.key)} invalid={fieldInvalid(q.NoOfFlatBatteries.key)} />
                </div>
            </div>
            {showECPB &&
                <>
                    <div className="te-main-form-header"> {q.ECPBPressures.value}</div>
                    <div className="main-form-row row-divider">
                        <Row className="mb-3">

                            {/* Left label */}
                            <Col sm="4">
                                <div className="te-question pt-2">
                                    {q.NoInoperableCars.value}
                                </div>
                            </Col>

                            {/* Right side */}
                            <Col sm="8">

                                {[1, 2, 3, 4].map((item, index) => (
                                    <Row key={index} className="align-items-center mb-2">

                                        {/* BP */}
                                        <Col sm="1" className="pe-0">
                                            <div className="te-question">{q.NoOfBp.value}</div>
                                        </Col>

                                        <Col sm="2" className="ps-1">
                                            <ECPBPressuresChoice
                                                onAnswerUpdate={handlePressureChange(index, "bPPressure")}
                                            />
                                        </Col>

                                        {/* RES */}
                                        <Col sm="1" className="pe-0">
                                            <div className="te-question">{q.NoOfRes.value}</div>
                                        </Col>

                                        <Col sm="2" className="ps-1">
                                            <ECPBPressuresChoice
                                                onAnswerUpdate={handlePressureChange(index, "rESPressure")}
                                            />
                                        </Col>

                                        {/* BC */}
                                        <Col sm="1" className="pe-0">
                                            <div className="te-question">{q.NoOfBc.value}</div>
                                        </Col>

                                        <Col sm="2" className="ps-1">
                                            <ECPBPressuresChoice
                                                onAnswerUpdate={handlePressureChange(index, "bCPressure")}
                                            />
                                        </Col>

                                    </Row>
                                ))}

                            </Col>

                        </Row>

                    </div>
                </>
            }
            <div>
            </div>
            <div className="main-form-row row-divider">
                <div className="te-question"> {q.Supervisor.value}</div>
                <div className="answer">
                    <UserChoice
                        onAnswerUpdate={handleChange(q.Supervisor.key)}
                        invalid={fieldInvalid(q.Supervisor.key)} />
                </div>
            </div>
        </div>

    );
}



type ResultModalProps = {
    submittedExemptionId: number,
    isOpen: boolean,
    closeAction: () => void
}

const ResultModal = (props: ResultModalProps) => {
    const formTitle = () => {
        return "Train Event Record Form";
    }

    return (
        <FormModal {...props} headingText={formTitle()}>

            <FormModalSubHeader>
                <div>{`Thank you for submitting the ${formTitle()}.`}</div>
            </FormModalSubHeader>

            <FormModalPaddedBody>
                <div className="modal-body-content-container">

                    <div className="modal-body-content">
                        {typeof props.submittedExemptionId !== 'number' ?
                            <div className="p-2 pb-5"><WarningIcon className="icon-score-low mr-4" />Something went wrong. Please raise an Incident or contact the Service Desk.</div>
                            :
                            <div className="p-2 pb-5">
                                <InfoIcon className="icon-score-low mr-4 mb-3" />
                                <div className="d-inline-block">
                                    Train event record request form successfully submitted.<br />
                                </div>
                            </div>
                        }
                    </div>

                    <ModalButtonRow>
                        <ModalButton onClick={props.closeAction} text="OK" primaryButton={true} />
                    </ModalButtonRow>

                </div>
            </FormModalPaddedBody>
        </FormModal>
    );
}

const FormContents = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form, setForm] = useState({} as TrainEventRecordModel);
    const [responseId, setResponseId] = useState(0);
    const [displayResponseModal, setResponseModal] = useState(false);
    const [displayAllRequired, setAllRequired] = useState(false);
    const [defaultEventTime, setDefaultEventTime] = useState(formatTime(new Date()));
    const navigate = useNavigate();

    const onSubmit = async () => {
        enableValidation();
        let submitTrainEvent = getTrainEventRecord();
        let unansweredCount = 0;
        try {
            unansweredCount = await submitIfAble(submitTrainEvent);
        }
        finally {
            if (unansweredCount > 0) {
                setAllRequired(true);
                setIsSubmitting(false);
            }
        }
    }

    const getTrainEventRecord = () => {
        let trainEventRecord = {} as SubmitTrainEventRecordModel;
        trainEventRecord.trainSerialNumber = form.trainSerialNumber;
        trainEventRecord.eventDate = form.eventDate ?? toISOLocalDate(new Date());
        trainEventRecord.eventTime = form.eventTime ?? defaultEventTime;
        trainEventRecord.durationOfDelay = form.durationOfDelay;
        trainEventRecord.driversDepot = form.driversDepot || -1;;
        trainEventRecord.leadLoco = Boolean(form.leadLoco);
        trainEventRecord.remoteLoco = Boolean(form.remoteLoco);
        trainEventRecord.trailLocoB = Boolean(form.trailLocoB);
        trainEventRecord.trailLocoA = Boolean(form.trailLocoA);
        trainEventRecord.brakeTypeId = Array.isArray(form.brakeType) ? form.brakeType.join(",") : "";
        trainEventRecord.leaderActive = Boolean(form.leaderActive);
        trainEventRecord.eotNo = form.eotNo;
        trainEventRecord.line = Number(form.line);
        trainEventRecord.kmPeg = form.kmPeg;
        trainEventRecord.isLoaded = form.isLoaded;
        trainEventRecord.weatherConditions = form.weatherConditions,
            trainEventRecord.supervisorId = Number(form.supervisorName?.id || -1),
            trainEventRecord.percentageOperable = form.percentageOperable,
            //Incident Details
            trainEventRecord.TrainIncidentDetails = {} as TrainIncidentDetailsModel;
        trainEventRecord.TrainIncidentDetails.incidentType = Array.isArray(form.incident) ? form.incident.join(",") : "";
        trainEventRecord.TrainIncidentDetails.result = Array.isArray(form.result) ? form.result.join(",") : "";
        trainEventRecord.TrainIncidentDetails.radioFault = Array.isArray(form.radioFaultType) ? form.radioFaultType.join(",") : "";
        trainEventRecord.TrainIncidentDetails.sequenceOfEvents = form.sequenceOfEvents;
        trainEventRecord.TrainIncidentDetails.faultKmStart = form.faultKmStart;
        trainEventRecord.TrainIncidentDetails.faultKmEnd = form.faultKmEnd;
        trainEventRecord.TrainIncidentDetails.handhelSerialNo = form.handhelSerialNo;

        trainEventRecord.TrainECPBModelList = {} as TrainECPBModel[];
        trainEventRecord.TrainECPBModelList =
            form.TrainECPBModelList?.map((item: TrainECPBModel) => ({
                bPPressure: Number(item.bPPressure),
                rESPressure: Number(item.rESPressure),
                bCPressure: Number(item.bCPressure)
            })) || [];

        return trainEventRecord;
    }

    const submitIfAble = async (submitTrainEvent: SubmitTrainEventRecordModel) => {
        let unansweredCount = 0;
        unansweredCount = questionsUnanswered(submitTrainEvent);
        if (unansweredCount === 0) {
            submitTrainEventRecord(submitTrainEvent).then(submitResponse);
        }
        return unansweredCount;
    }

    const submitResponse = (trainEventId: number) => {
        setIsSubmitting(false);

        if (typeof trainEventId !== 'number') {
            errorResponse(undefined);
            return;
        }

        showResponse(trainEventId);
    }

    const showResponse = (trainEventId: number) => {
        setResponseId(trainEventId);
        setResponseModal(true);
        te.reset();
    }

    const errorResponse = (e: any) => {
        if (e !== undefined) {
            console.error(e);
        }
        setIsSubmitting(false);
    }

    const closeResponse = () => {
        setResponseModal(false);
        navigate(`${trainEventRecordOverviewPathRoute.path}`);
    }

    useEffect(() => {
        const deSub = te.subscribe((d: TrainEventRecordState) => {
            setForm(d.form);
            setAllRequired(false);
        });

        return () => {
            deSub.unsubscribe();
        };
    }, [form]);

    useEffect(() => {
        te.reset();
    }, []);

    return (
        <>
            <div className="te-main-form-header">Enter all details and click submit</div>
            <ResultModal submittedExemptionId={responseId} isOpen={displayResponseModal} closeAction={closeResponse} />

            <MainForm defaultEventTime={defaultEventTime} />
            <div className="main-form-row form-end">
                <div className={`invalid-feedback mandatory-details${displayAllRequired === true ? " show" : ""}`}>Please enter all mandatory details in the form.</div>
                <div className="submit">
                    {isSubmitting ?
                        <>
                            <div className="modal fade show" role="dialog" tabIndex={-1}></div>
                            <Button className="btn-primary disabled">Submitting...</Button>
                        </>
                        :
                        <>
                            <Button className={`btn-primary`} onClick={onSubmit}>Submit</Button>
                        </>
                    }
                </div>
            </div>
        </>
    );
}

export default FormContents;